var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1StarR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 62,
    viewBox: "0 0 103 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9574 51.8835L26.7124 57.1676L24.3891 47.2085L32.1241 40.5076L21.9383 39.6293L17.9574 30.251L13.9766 39.6293L3.79077 40.5076L11.5116 47.2085L9.20244 57.1676L17.9574 51.8835Z",
    fill: "#FECC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9574 51.8835L94.7124 57.1676L92.3891 47.2085L100.124 40.5076L89.9383 39.6293L85.9574 30.251L81.9766 39.6293L71.7908 40.5076L79.5116 47.2085L77.2024 57.1676L85.9574 51.8835Z",
    fill: "#CFCFCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9574 24.8835L60.7124 30.1676L58.3891 20.2085L66.1241 13.5076L55.9383 12.6293L51.9574 3.25098L47.9766 12.6293L37.7908 13.5076L45.5116 20.2085L43.2024 30.1676L51.9574 24.8835Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1StarR);
export default __webpack_public_path__ + "static/media/1star-r.ece927bdda84287fd338de6fd8475194.svg";
export { ForwardRef as ReactComponent };